import { createIconFromSvg } from '../icons';
import { ReactComponent as Pending } from './pending.svg';

export const PendingIcon = createIconFromSvg(Pending, '0 0 24 24');
